import { gql } from '@apollo/client';

import { StudentAssignment } from '@ts-core/modules/assignments/types';
import { studentAssignment } from '@ts-core/modules/assignments/graphql/fragments';

export interface GetStudentAssignmentsQueryVariables {
  courseId: string;
  studentId: string;
}

export interface GetStudentAssignmentsQueryResult {
  studentAssignments: StudentAssignment[];
}

export const getStudentAssignmentsQuery = gql`
  query GetStudentAssignments($courseId: String!, $studentId: String!) {
    studentAssignments(courseId: $courseId, studentId: $studentId)
      @rest(type: "StudentAssignment", path: "courses/{args.courseId}/students/{args.studentId}/assignments") {
      ...StudentAssignment
    }
  }
  ${studentAssignment}
`;
